import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly"
import createSagaMiddleware from "redux-saga"
import { IS_BROWSER, IS_DEV, WINDOW } from "constants/environment"
import rootReducer from "store/reducers"
import { rootSagas, locationActions, locationSelectors, environmentActions } from "store/actions"

import { pick, rafThrottle } from "utils"

// GTM
import gtmMapEvents from "store/gtm-events/index-main"
import { createMiddleware } from "redux-beacon"
import { logger } from "redux-beacon/extensions/logger"
import { GoogleTagManager } from "redux-beacon/targets/google-tag-manager"
import { offlineWeb } from "redux-beacon/extensions/offline-web"

let store = null

// For futire if we want to develop offiline mode (state) => isConnected
const offlineStorage = offlineWeb(() => true)
const googleTagManagerMiddleware = createMiddleware(gtmMapEvents, GoogleTagManager(), {
  logger: IS_DEV ? logger : null, // Disable logging for unit tests
  offlineStorage
})
// const googleTagManagerMiddleware = createMiddleware(gtmEventMap, GoogleTagManager())
const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = composeWithDevTools({
  name: "KOALA",
  actionCreators: locationActions
})
const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware, googleTagManagerMiddleware))

export function configureStore(initialState = {}) {
  return createStore(rootReducer, initialState, enhancer)
}

export default function getStore(initalProps) {
  if (store) {
    return store
  }
  // dbg && console.trace('Configuring new store') // eslint-disable-line
  store = configureStore({ data: initalProps })
  if (IS_BROWSER && WINDOW) {
    sagaMiddleware.run(rootSagas)

    // Initiate a location fetch always regardless of the presence of location aware components
    const { state } = locationSelectors.getLocation(store.getState())

    if (!state) store.dispatch(locationActions.fetchLocation())

    // Handle resize and scroll in one spot
    const pickDimensions = pick(["innerWidth", "innerHeight"])
    const pickScroll = pick(["scrollY"])

    store.dispatch(environmentActions.updateWindowSize(pickDimensions(WINDOW)))
    store.dispatch(environmentActions.updateWindowScroll(pickScroll(WINDOW)))

    WINDOW.addEventListener(
      "resize",
      rafThrottle(() => store.dispatch(environmentActions.updateWindowSize(pickDimensions(WINDOW))))
    )
  }

  return store
}



// WEBPACK FOOTER //
// ./src/store/index.js